import { useState } from "react";

import { AuthorizationStatusEnum } from "../services/authorizationService/getAuthorization";
import { crefazCltService } from "../services/crefazCltService";
import { PartnerType } from "../utils/partners.enum";
import { useAuthorizationId } from "./useAuthorizationId";
import { useToast } from "@/view/components/ui/use-toast";

type UseCrefazCltAuthorizationOptions = {
  initialStatus?: AuthorizationStatusEnum;
  initialSmsSent?: boolean;
};

export const useCrefazCltAuthorization = (
  preTransactionId?: string,
  { initialStatus, initialSmsSent }: UseCrefazCltAuthorizationOptions = {},
) => {
  const { toast } = useToast();

  const [isSendingSms, setIsSendingSms] = useState(false);
  const [smsSent, setSmsSent] = useState(Boolean(initialSmsSent));
  const [status, setStatus] = useState(initialStatus);

  const { data, isLoading, isError } = useAuthorizationId(
    preTransactionId,
    PartnerType.CREFAZ_CLT,
  );

  if (data?.status && data.status !== status) {
    setStatus(data.status);
  }

  if (data?.autorizacaoEnviada && !smsSent) {
    setSmsSent(true);
  }

  const sendSms = async () => {
    if (!preTransactionId) return;

    try {
      setIsSendingSms(true);

      const response =
        await crefazCltService.postAuthorization(preTransactionId);

      setSmsSent(true);

      toast({
        title: "SMS de autorização enviado",
        description:
          response.processo?.mensagem ||
          "O cliente precisa responder para liberar a consulta.",
      });
    } catch (error: any) {
      toast({
        title: "Não foi possível enviar o SMS",
        description: error?.message || "Tente novamente em alguns instantes.",
        variant: "destructive",
      });
    } finally {
      setIsSendingSms(false);
    }
  };

  return {
    status,
    observation: data?.observation,
    customer: data?.customer,
    isLoading,
    isError,
    smsSent,
    isSendingSms,
    sendSms,
  };
};
